import PatientStyle from './Patients.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { Box, Button, Card, IconButton, Tooltip, Typography } from '@mui/material';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import PatientDialog from './PatientDialog';
import CommonAgGrid from '../../components/CommonAgGrid/CommonAgGrid';
import { deletePatient, getPatients } from '../../apis/patientSlice';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import PatientFormDialog from '../patientForm/PatientFormDialog';
import DeleteDialog from '../../components/DeleteDialog';


export default function Patients({ search }) {
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [operationMode, setOperationMode] = useState('Add');
  const [appointmentFormOpen , setAppointmentFormOpen] = useState(false);
  const [selectedPatient , setSelectedPatient] = useState(null);
  const [selectedPatientFormId , setSelectedPatientFormId] = useState(null);

  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);


  const { loggedIn } = useSelector((state) => state.authData);
  const { patients, loading, totalCount } = useSelector((state) => state.patientData);
  // const { patientsForm, loading, totalCount } = useSelector((state) => state.patientFormData);


  async function callApi() {
    dispatch(getPatients({ page, pageSize, search: search || "" }));
  }
  // async function callApi() {
  //   dispatch(getPatientsForm({ page, pageSize, search: search || '' }));
  // }

  useEffect(() => {
    callApi();
  }, [page, pageSize, dispatch, loggedIn, search]);

  const handlePaginationModelChange = (model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  // const handleEdit = (data) => {
  //   navigate(`/assessmentform/${data._id}`);
  // };


  const handleEdit = (data) => {
  setEditData(data);        // ← set row data in state
  setOperationMode("Edit"); // ← switch dialog mode
  setOpen(true);            // ← open patient dialog
};




  const handleDelete = async (data) => {
    const response = await dispatch(deletePatient(data._id));
    // const response = await dispatch(deletePatientForm(data._id));

    if (response?.payload?.success) {
      toast.success(response?.payload.message);
      callApi();
    } else {
      toast.error('Error deleting patient');
    }
  };

  const handleDeleteClick = (data) => {
    setDeleteRow(data);
    setDeleteOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteRow) return;
    await handleDelete(deleteRow);
    setDeleteOpen(false);
    setDeleteRow(null);
  };

  const handleCancelDelete = () => {
    setDeleteOpen(false);
    setDeleteRow(null);
  };

  // const handleOpenAppointmentForm = (id , patientFormId) => {
  //    setAppointmentFormOpen(true);
  //     setSelectedPatient(id);
  //     setOperationMode("Add") 
  //     setSelectedPatientFormId(patientFormId);
  // }
  const handleOpenAppointmentForm = (patient) => {
     setAppointmentFormOpen(true);
      setSelectedPatient(patient);
      setOperationMode("Add") 
      // setSelectedPatientFormId(patientFormId);
  }

  const columns = useMemo(
    () => [
      { field: 'clinicName', headerName: 'Clinic Name', minWidth: 120, flex: 1, valueGetter: (p) => p.data?.clinicId?.name || '-' },
      { field: 'name', headerName: 'Name', minWidth: 140, flex: 1 },
      { field: 'phone', headerName: 'Phone', minWidth: 120, flex: 0.9 },
      { field: 'pincode', headerName: 'Pincode', minWidth: 85, flex: 0.7 },
      { field: 'address', headerName: 'Address', minWidth: 130, flex: 1.1 },
      { field: 'city', headerName: 'City', minWidth: 100, flex: 0.8 },
      { field: 'state', headerName: 'State', minWidth: 100, flex: 0.8 },
      {
        colId: 'bookAppointment',
        headerName: 'Appointment',
        minWidth: 130,
        flex: 0.9,
        sortable: false,
        cellRenderer: (params) =>
          params.data?.clinicId?._id === '69788a0b7fdb4e1be424cd2c' ||
          params.data?.clinicId?._id === '6953552a6f3a9dfdfe0b10d7' ? (
            <Button
              variant="contained"
              className={PatientStyle.bookBtn}
              onClick={() => handleOpenAppointmentForm(params.data)}
            >
              Book
            </Button>
          ) : null,
      },
      {
        colId: 'actions',
        headerName: 'Action',
        width: 96,
        flex: 0,
        minWidth: 96,
        maxWidth: 96,
        sortable: false,
        pinned: 'right',
        cellRenderer: (params) => (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Tooltip title="Edit">
              <IconButton onClick={() => handleEdit(params.data)} color="primary" size="small" aria-label="edit">
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton onClick={() => handleDeleteClick(params.data)} color="error" size="small" aria-label="delete">
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [],
  );

  return (
    <div className={PatientStyle.page}>
      <DeleteDialog
        open={deleteOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        compact
      />
      <Box className={PatientStyle.pageHead}>
        <Typography className={PatientStyle.pageTitle}>Patients</Typography>
      </Box>
      <Card className={PatientStyle.tableCard}>
        <div className={PatientStyle.tableHeader}>
          <h2 className={PatientStyle.tableTitle}>Patient List</h2>
          <Button
            className={PatientStyle.addBtn}
            variant="contained"
            size="small"
            startIcon={<HealthAndSafetyIcon />}
            onClick={() => { setOpen(true); setOperationMode("Add") }}
          >
            Add Patients
          </Button>
        </div>
        <CommonAgGrid
          rowData={patients || []}
          columnDefs={columns}
          getRowId={(p) => String(p.data._id)}
          loading={loading}
          height={280}
          pagination
          paginationMode="server"
          rowCount={Number(totalCount) || 0}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={handlePaginationModelChange}
          pageSizeOptions={[5, 10, 25, 50, 100]}
        />
        <PatientDialog
          open={open}
          setOpen={setOpen}
          editData={editData}
          operationMode={operationMode}
          setOperationMode={setOperationMode}
          callApi={callApi}
        />
        <PatientFormDialog
          open={appointmentFormOpen}
          // editData={editData}
          setOpen={setAppointmentFormOpen}
          operationMode={operationMode}
          setOperationMode={setOperationMode}
          selectedPatient={selectedPatient}
          setSelectedPatient={setSelectedPatient}
          callApi={callApi}
          selectedPatientFormId={selectedPatientFormId}
        setSelectedPatientFormId={setSelectedPatientFormId}
        />
      </Card>
    </div>
  );
}
